var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChannelsFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 47.7333C8.66667 45.7333 0 35.8667 0 24C0 10.8 10.8 0 24 0C37.2 0 48 10.8 48 24C48 35.8667 39.3333 45.7333 28 47.7333L26.6667 46.6667H21.3333L20 47.7333Z",
    fill: "url(#paint0_linear_853_13132)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 30.6667L34.4 24H28V19.3333C28 17.4667 28.6667 16 31.6 16H34.6667V9.86668C32.9333 9.60001 31.0667 9.33334 29.3333 9.33334C23.8667 9.33334 20 12.6667 20 18.6667V24H14V30.6667H20V47.6C21.3333 47.8667 22.6667 48 24 48C25.3333 48 26.6667 47.8667 28 47.6V30.6667H33.3333Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_853_13132",
    x1: 24,
    y1: 46.3387,
    x2: 24,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0062E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19AFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelsFacebook);
export default __webpack_public_path__ + "static/media/ChannelsFacebook.e400ac6744c0a0f0354db4608a46e891.svg";
export { ForwardRef as ReactComponent };